<script>
	import Navbar from "../Navbar.svelte";
	import Footer from "../components/Footer.svelte";
	import { handleSubmit, parseFormdata, updateNextRoute } from "../utils.js";
	import { api_writeForm, disableNextButton } from "../stores.js";
	import { useForm, validators, required } from "svelte-use-form";
	// https://svelte.dev/repl/d4fc021f688d4ad0b3ceb9a1c44c9be9?version=3.34.0

	export let redirectRoute;
	updateNextRoute();
	redirectRoute = localStorage.getItem("nextRoute");
	const form = useForm();

	const handleClick = () => {
		let formData = parseFormdata($form);
		delete formData.murder;
		delete formData["gays-lesbians"];
		delete formData.taxes;
		handleSubmit($api_writeForm, formData, redirectRoute);
	};

	let fields = [
		// fillerQuestionMurder
		{
			labelName: "murder",
			label: "People convicted of murder should be given the death penalty.",
			options: [
				{
					type: "radio",
					value: "1_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "2_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "3_neither-agree-nor-disagree",
					option: "Neither agree nor disagree",
				},
				{
					type: "radio",
					value: "4_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "5_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},
		// attentionCheck
		{
			labelName: "attentioncheck1",
			label: "Please click the 'Neither agree nor disagree' response.",
			options: [
				{
					type: "radio",
					value: "1_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "2_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "3_neither-agree-nor-disagree",
					option: "Neither agree nor disagree",
				},
				{
					type: "radio",
					value: "4_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "5_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},
		// fillerQuestionGays
		{
			labelName: "gays-lesbians",
			label: "Gays and lesbians should have the right to legally marry.",
			options: [
				{
					type: "radio",
					value: "1_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "2_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "3_neither-agree-nor-disagree",
					option: "Neither agree nor disagree",
				},
				{
					type: "radio",
					value: "4_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "5_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},
		// fillerQuestionTaxes
		{
			labelName: "taxes",
			label: "In order to reduce the budget deficit, the federal government should raise taxes on people that make more than $250,000 per year.",
			options: [
				{
					type: "radio",
					value: "1_strongly-agree", // value/response to send to server
					option: "Strongly agree", // what to display
				},
				{
					type: "radio",
					value: "2_agree",
					option: "Agree",
				},
				{
					type: "radio",
					value: "3_neither-agree-nor-disagree",
					option: "Neither agree nor disagree",
				},
				{
					type: "radio",
					value: "4_disagree",
					option: "Disagree",
				},
				{
					type: "radio",
					value: "5_strongly-disagree",
					option: "Strongly disagree",
				},
			],
		},
	];

	// fields = fields.slice(fields.length - 2, fields.length);
</script>

<Navbar />

<section>
	<h1>How much do you agree or disagree with the following statements?</h1>
	<form use:form>
		{#each fields as field, fi}
			<div class="field-container">
				<label for={field.labelName}>{@html field.label} </label>
				{#each field.options as option, oi}
					<div class="option-group">
						<input
							name={field.labelName}
							type={option.type}
							value={option.value}
							use:validators={[required]}
						/>
						<span class="option"> {option.option} </span>
					</div>
				{/each}
			</div>
		{/each}

		<button
			disabled={!$form.valid && $disableNextButton}
			on:click|preventDefault={handleClick}>Next</button
		>
	</form>
</section>

<Footer />

<style>
	@media (max-width: 700px) {
		section {
			padding-left: 8%;
			padding-right: 8%;
		}
	}

	button {
		margin-bottom: 144px;
	}

	label {
		margin-bottom: 13px;
		font-size: 1.1em;
	}

	input {
		margin-right: 1px;
	}

	.field-container {
		margin-bottom: 34px;
	}

	.option {
		margin-right: 13px;
	}

	.option-group {
		display: inline;
	}

	@media (max-width: 1597px) {
		.option-group {
			display: block;
		}
	}
</style>
